import e from "./index104.js";
//#region src/theme/tokens.ts
var { breakpoints: t } = e({ breakpoints: { values: {
	xs: 0,
	sm: 640,
	md: 800,
	lg: 960,
	xl: 1272
} } }), n = e({
	breakpoints: { values: { ...t.values } },
	shadow: { neutral: {
		stickyTop: "0 -4px 8px 1px rgba(0, 0, 0, 0.16)",
		stickyBottom: "0 -4px 8px 1px rgba(0, 0, 0, 0.16)",
		default: "0 1px 8px 0 rgba(0, 0, 0, 0.16)",
		defaultActive: "0 4px 16px 0 rgba(0, 0, 0, 0.16)",
		weak: "0 1px 2px 1px rgba(0, 0, 0, 0.08)",
		moderate: "0 8px 9px -8px rgba(0, 0, 0, 0.16)",
		strong: "0 14px 4px 0px rgba(0, 0, 0, 0.2)",
		[t.up("sm")]: { moderate: "0 16px 16px -16px rgba(0, 0, 0, 0.16)" }
	} },
	typo: {
		fontFamily: "gt-eesti, Arial",
		hero: { default: {
			fontSize: "46px",
			fontWeight: 900,
			lineHeight: "100%",
			[t.up("sm")]: { fontSize: "54px" }
		} },
		title: {
			primary: {
				fontSize: "28px",
				fontWeight: 900,
				lineHeight: "110%",
				[t.up("sm")]: { fontSize: "38px" }
			},
			secondary: {
				fontSize: "22px",
				fontWeight: 500,
				lineHeight: "110%"
			},
			tertiary: {
				fontSize: "18px",
				fontWeight: 500,
				lineHeight: "110%"
			}
		},
		label: {
			default: {
				fontSize: "16px",
				fontWeight: 500,
				lineHeight: "110%"
			},
			small: {
				fontSize: "14px",
				fontWeight: 500,
				lineHeight: "110%"
			}
		},
		body: {
			default: {
				fontSize: "16px",
				fontWeight: 400,
				lineHeight: "120%"
			},
			small: {
				fontSize: "14px",
				fontWeight: 400,
				lineHeight: "120%"
			},
			tooSmall: {
				fontSize: "12px",
				fontWeight: 400,
				lineHeight: "140%"
			}
		}
	},
	radius: {
		default: "16px",
		weak: "8px",
		moderate: "12px",
		strong: "24px",
		round: "9999px"
	},
	measure: {
		size: {
			min: "4px",
			xs: "8px",
			s: "16px",
			m: "24px",
			l: "32px",
			xl: "40px",
			xxl: "48px",
			xxxl: "56px",
			layout: {
				sectionLarge: "1016px",
				sectionSmall: "662px",
				sectionMax: "1320px",
				sectionSidebar: "360px"
			},
			controls: {
				button: "48px",
				input: "48px",
				searchForm: "56px"
			}
		},
		spacing: {
			horizontal: {
				min: "2px",
				smaller: "16px",
				default: "24px"
			},
			vertical: {
				min: "2px",
				smaller: "8px",
				default: "12px",
				larger: "16px",
				max: "24px"
			},
			gap: {
				min: "4px",
				narrow: "8px",
				smaller: "12px",
				default: "16px",
				larger: "24px",
				max: "48px"
			}
		}
	},
	color: {
		neutral: {
			txt: {
				default: "rgba(0, 21, 54, 1)",
				weak: "rgba(87, 102, 128, 1)",
				moderate: "rgba(87, 102, 128, 1)",
				inverted: "#FFFFFF",
				invertedActive: "#FFFFFF"
			},
			bg: {
				default: "#FFFFFF",
				defaultActive: "rgba(245, 247, 251, 1)",
				deep: "rgba(245, 247, 251, 1)",
				delicate: "rgba(233, 236, 240, 1)",
				weak: "rgba(233, 236, 240, 1)",
				moderate: "rgba(20, 104, 153, 1)",
				strong: "rgba(0, 21, 54, 1)",
				elevated: "#FFFFFF"
			},
			border: {
				default: "rgba(48, 50, 51, 0.12)",
				defaultActive: "rgba(48, 50, 51, 0.16)",
				weak: "rgba(48, 50, 51, 0.08)",
				moderate: "rgba(20, 104, 153, 1)",
				strong: "rgba(0, 21, 54, 1)"
			}
		},
		accent: {
			txt: {
				default: "rgba(0, 102, 212, 1)",
				defaultActive: "rgba(0, 86, 178, 1)",
				strong: "rgba(2, 25, 62, 1)",
				strongActive: "rgba(4, 46, 114, 1)",
				inverted: "#FFFFFF",
				invertedActive: "#FFFFFF"
			},
			bg: {
				default: "rgba(0, 113, 235, 1)",
				defaultActive: "rgba(0, 101, 209, 1)",
				weak: "rgba(230, 242, 254, 1)",
				strong: "rgba(0, 21, 54, 1)",
				strongActive: "rgba(0, 31, 82, 1)"
			}
		},
		disabled: {
			txt: {
				default: "rgba(181, 184, 189, 1)",
				moderate: "rgba(118, 132, 153, 1)"
			},
			bg: { default: "rgba(215, 219, 224, 1)" },
			border: { default: "rgba(48, 50, 51, 0.04)" }
		},
		success: {
			txt: {
				default: "rgba(41, 120, 86, 1)",
				inverted: "rgba(197, 255, 198, 1)"
			},
			bg: {
				default: "rgba(16, 112, 70, 1)",
				weak: "rgba(197, 255, 198, 1)"
			},
			border: { default: "rgba(16, 112, 70, 1)" }
		},
		warning: {
			txt: {
				default: "rgba(184, 68, 18, 1)",
				defaultActive: "rgba(139, 51, 14, 1)",
				strong: "rgba(66, 48, 7, 1)",
				moderate: "rgba(122, 95, 80, 1)",
				inverted: "#FFFFFF"
			},
			bg: {
				weak: "rgba(255, 231, 209, 1)",
				weakActive: "rgba(246, 234, 218, 1)",
				default: "rgba(255, 153, 58, 1)"
			}
		},
		danger: {
			txt: {
				default: "rgba(186, 48, 59, 1)",
				inverted: "#FFFFFF"
			},
			bg: {
				default: "rgba(193, 20, 23, 1)",
				defaultActive: "rgba(157, 16, 19, 1)",
				weak: "rgba(255, 218, 224, 1)"
			}
		},
		brand: { operatedBus: {
			primary: {
				default: "#054752",
				defaultActive: "#054752",
				inverted: "#FFFFFF",
				invertedActive: "#FFFFFF"
			},
			secondary: {
				default: "#FF595A",
				defaultActive: "#D64F45",
				inverted: "#FFFFFF",
				invertedActive: "#FFFFFF"
			}
		} }
	}
});
//#endregion
export { n as tokens };

//# sourceMappingURL=index325.js.map